import { types } from 'mobx-state-tree';

import FilterOption from './FilterOption';
import { FilterTypeType } from '../types/FilterType';

const Filter = types
  .model('Filter', {
    name: types.string,
    key: types.identifier,
    type: FilterTypeType,
    options: types.maybeNull(types.array(FilterOption)),
    step: types.maybeNull(types.number),
    unit: types.maybeNull(types.string),
    min: types.maybeNull(types.number),
    max: types.maybeNull(types.number),
  })
  .views((self) => ({
    /**
     * Total count for this filter (sum of option counts).
     * Null/undefined counts are treated as 0.
     */
    get totalCount() {
      const options = self.options || [];
      return options.reduce((sum, option) => {
        return sum + option.getCount;
      }, 0);
    },

    /**
     * Returns the count for a given option value.
     * @param {string|number|null|undefined} value
     */
    getOptionCount(value) {
      const options = self.options || [];
      const valueStr =
        value === null || value === undefined || value === '' || value === '0'
          ? '0'
          : String(value);
      const match = options.find((o) => String(o.value) === valueStr);
      return typeof match?.count === 'number' ? match.count : 0;
    },
  }));

export default Filter;
